import React, { useState } from "react"
import { UserCog } from "lucide-react"
import { Button } from "@/components/ui/button"
import {
  exitImpersonation,
  getImpersonatorUser,
  hasStoredImpersonationSession,
} from "./impersonateUser"

export function ImpersonationBanner() {
  const [isExiting, setIsExiting] = useState(false)
  const impersonating = hasStoredImpersonationSession()

  if (!impersonating) {
    return null
  }

  const impersonatorUser = getImpersonatorUser()
  const impersonatorLabel =
    [impersonatorUser?.info?.firstName || impersonatorUser?.firstName, impersonatorUser?.info?.lastName || impersonatorUser?.lastName]
      .filter(Boolean)
      .join(" ")
      .trim() ||
    impersonatorUser?.email ||
    "your admin account"

  const handleExit = async () => {
    setIsExiting(true)
    try {
      await exitImpersonation()
    } catch (error) {
      console.error("Failed to exit impersonation:", error)
      setIsExiting(false)
    }
  }

  return (
    <div
      role="status"
      className="w-full border-b border-amber-200 dark:border-amber-900/60 bg-amber-50 dark:bg-amber-950/50 px-4 py-2 flex flex-wrap items-center justify-center gap-3 text-sm text-amber-900 dark:text-amber-100"
    >
      <UserCog className="h-4 w-4 shrink-0 text-amber-700 dark:text-amber-300" aria-hidden />
      <span className="text-center">
        You are impersonating another user. Return to <span className="font-medium">{impersonatorLabel}</span> when finished.
      </span>
      <Button
        type="button"
        size="sm"
        variant="outline"
        disabled={isExiting}
        onClick={handleExit}
        className="h-8 border-amber-300 dark:border-amber-700 bg-white/80 dark:bg-amber-950/80 text-amber-950 dark:text-amber-50 hover:bg-amber-100 dark:hover:bg-amber-900/60"
      >
        {isExiting ? "Returning…" : "Back to admin account"}
      </Button>
    </div>
  )
}
